import {Component, NgZone} from '@angular/core';
import {Events, IonicPage, NavController, NavParams} from 'ionic-angular';
import {AppChatDetailsPage} from "../app-chat-details/app-chat-details";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ChatClientProvider} from "../../providers/chat-client/chat-client";
import {AppForumListPage} from "../app-forum-list/app-forum-list";
import {ChatStateProvider} from "../../providers/chat-state/chat-state";

/**
 * Generated class for the AppChatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-chat',
  templateUrl: 'app-chat.html',
})
export class AppChatPage {

  chatDetailsPage: any = AppChatDetailsPage;
  private channelData: Map<string, any>;
  eventHandler: any;
  forumListPage: any = AppForumListPage;
  messageCount: number = 0;
  partnerMessageCount: number = 0;
  unreadTopicsCount: number = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, public state: UserStateProvider, public chatClient: ChatClientProvider, public events: Events, public ngzone: NgZone, public chatState: ChatStateProvider) {
    this.channelData = new Map<string, any>();

    var me = this;
    this.eventHandler = msgData => {
      console.log(me);
      me.messageCount++;
      if(me.channelData.get(msgData.conversation_id)) {
        me.channelData.get(msgData.conversation_id).unread++;
      }
    };
    this.events.subscribe('message:received', this.eventHandler);
    this.events.subscribe('chat:opened', () => {
      this.messageCount = 0;
    });
    this.events.subscribe('forum:topicViewedProcessed', () => {
      this.unreadTopicsCount = this.chatState.getUnreadTopicsCount();
    });

  }

  ionViewWillEnter() {
    console.log('here');
    var me = this;
    this.channelData = new Map<string, any>();
    if(!this.chatClient.checkConnection()) {
      this.chatClient.connect();
    }
    this.chatClient.checkConnection().then(() => {
        me.chatClient.loadConversations().then((data: any) => {
          for(var l in data) {

            if(data[l].id!='public') {
              this.messageCount = data[l].unread;
            }

            me.channelData.set(data[l].id, data[l]);
          }

        })
    });

    console.log(me.state.user);

    this.unreadTopicsCount = this.chatState.getUnreadTopicsCount();
    this.partnerMessageCount = this.chatState.unreadPartnerChat?1:0;

    console.log('ionViewDidLoad AppChatPage');
  }

  ionViewDidLeave() {
    this.events.unsubscribe('message:received', this.eventHandler);
  }
  goBack() {
    this.navCtrl.parent.select(0);
  }


}



// WEBPACK FOOTER //
// ./src/pages/app-chat/app-chat.ts